import belImage from '../../../assets/images/clients/bel.webp';
import butecImage from '../../../assets/images/clients/butec.webp';
import ifasImage from '../../../assets/images/clients/ifas.webp';
import marocAkhchabImage from '../../../assets/images/clients/maroc-akhchab.webp';
import aquamdImage from '../../../assets/images/clients/aquamd.webp';
import renaultImage from '../../../assets/images/clients/renault.png';
import stellantisImage from '../../../assets/images/clients/stellantis.webp';
import veoliaImage from '../../../assets/images/clients/veolia.webp';
import yazakiImage from '../../../assets/images/clients/yazaki.webp';


export interface Partner {
  name: string;
  image: string;
  url?: string;
}

// Create partners array with all available partners
export const clients: Partner[] = [
  {
    name: 'Bel',
    image: belImage,
    url: 'https://bel.ma'

  }
  ,
  {
    name: 'Butec',
    image: butecImage,
    url: 'https://butec.com'
  },
  {
    name: 'Ifas KSA',
    image: ifasImage,
    url: 'https://ifas-ksa.com'
  },
  {
    name: 'Maroc Akhchab',
    image: marocAkhchabImage,
    url: 'https://www.marocakhchab.com'
  },
  {
    name: 'Quamd',
    image: aquamdImage,
    url: 'https://aquamdiq.ma/'
  },
  {
    name: 'Renault',
    image: renaultImage,
    url: 'https://renault.ma'
  },
  {
    name: 'Stellantis',
    image: stellantisImage,
    url: 'https://stellantis.ma'
  },
  {
    name: 'Veolia',
    image: veoliaImage,
    url: 'https://veolia.ma'
  },
  {
    name: 'Yazaki',
    image: yazakiImage,
    url: 'https://www.yazaki-europe.com/'
  }
];
